import React from 'react'
import PropTypes from 'prop-types'

import { LinkView } from 'Components/Link/View'
import { LinkEdit } from 'Components/Link/Edit'

const getStatusLabelStyle = status => {
  if (status.toUpperCase() === 'ARCHIVED') {
    return {
      backgroundColor: 'hsl(210, 10%, 89%)',
      color: 'hsl(217, 21%, 26%)',
    }
  }
  return null
}

export const CityCardUnstyled = props => {
  const { city, className, editPath, tileClickHandler, viewPath } = props
  if (!city) return null
  return (
    <div className={`${className} city-card`}>
      <div onClick={tileClickHandler}>
        <div className="title-status">
          <span>{city.name}</span>
          <label style={getStatusLabelStyle(city.statusV2)}>
            {city.statusV2}
          </label>
        </div>
      </div>
      <div className="actions">
        <LinkView to={viewPath} label="View" />
        <LinkEdit to={editPath} label="Edit" />
      </div>
    </div>
  )
}

CityCardUnstyled.propTypes = {
  city: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  editPath: PropTypes.string.isRequired,
  tileClickHandler: PropTypes.func.isRequired,
  viewPath: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/Components/City/Card/unstyled.js